import React from "react";
import T from "prop-types";
import { NO_CAPES } from "MODULES/RepairQuotes/constants";

const quoteStyle = lineItem => {
  switch (lineItem.quote_type) {
    case NO_CAPES:
      return { borderLeft: "3px solid #f44336" };
    default:
      return {};
  }
};

export default function LineItemStatusCell({ lineItem, children }) {
  return <td style={quoteStyle(lineItem)}>{children}</td>;
}

LineItemStatusCell.propTypes = {
  lineItem: T.shape({}),
  children: T.oneOfType([T.node, T.arrayOf(T.node)])
};



// WEBPACK FOOTER //
// ./app/modules/RepairQuotes/styles.jsx